
      var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRadioChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15,
  fill: "var(--theme-primary, #810ea9)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.469 13.93a1.526 1.526 0 0 1 2.262 0l3.669 3.931 6.869-7.359a1.526 1.526 0 0 1 2.262 0c.625.67.625 1.755 0 2.425l-8 8.57c-.624.67-1.637.67-2.262 0l-4.8-5.142a1.802 1.802 0 0 1 0-2.424z",
  fill: "var(--theme-light, #f9f3fb)"
})));

      const __svgRaw = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <circle cx=\"16\" cy=\"16\" r=\"15\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.469 13.93a1.526 1.526 0 0 1 2.262 0l3.669 3.931 6.869-7.359a1.526 1.526 0 0 1 2.262 0c.625.67.625 1.755 0 2.425l-8 8.57c-.624.67-1.637.67-2.262 0l-4.8-5.142a1.802 1.802 0 0 1 0-2.424z\" fill=\"var(--theme-light, #f9f3fb)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/radio-checked.df4d5371410f813ba5127107c38cccb3.svg"),
        {
          React: SvgRadioChecked,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      